import React from "react";

import Container from "@mui/material/Container";

import "swiper/css/navigation";
import "swiper/css";

import Testimonialdata from "./Testimonialdata";

const Testimonial = () => {
  return (
    <div className="QL__PG__Sec__Testimonial">
      <Container>
        <h1 className="HeadingAll pb-5">Testimonial</h1>
        
       
        <Testimonialdata/>
      </Container>
    </div>
  );
};
export default Testimonial;
